import React, { useEffect} from 'react'
import {Row, Col, Container} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import Product from '../components/Product'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { listProducts } from '../actions/productActions'
import { useLocation } from 'react-router-dom';
import Paginate from '../components/Paginate'
import Hero from '../components/Hero'
import Filters from '../components/Filters'

function HomeScreen({ showHero=true, title='All Products' }) {
  const dispatch = useDispatch()
  const location = useLocation()
  
  const productList = useSelector(state => state.productList)
  const {error, loading, products, page, pages} = productList

  let keyword = location.search
  console.log(keyword)
  useEffect(() => {
    dispatch(listProducts(keyword))


  }, [dispatch, keyword])

  
  return (
    <div>
      {showHero && !keyword && <Hero/> }
      <Container id="products">
        <div className="d-flex align-items-center justify-content-between">
          <h2 className="ws-section-title mb-0">{title}</h2>
          {!loading && <div className="ws-muted"> {products ? products.length : 0} products</div>}
        </div>
        {loading ? <Loader/> : error ? <Message variant='danger'> {error} </Message> :
        <div className="ws-layout mt-3">
          <div>
            <Filters/>
          </div>
          <div>
            <Row>
              {products.map(product => (
                <Col key={product._id} sm={12} md={6} lg={4} xl={3} className="mb-4">
                  <Product product={product} />
                </Col>
              ))}
            </Row>
            <Paginate pages={pages} page={page} keyword={keyword} />
          </div>
        </div>
        }
      </Container>
    </div>
  )
}

export default HomeScreen